module.exports = __webpack_public_path__ + "static/media/hand-holding.5c09fb8c.svg";